module.exports = __webpack_public_path__ + "media/init/static/fonts/GT-Eesti-Pro-Display-Medium-8e552399878d273f909d06e06a4f1ffb.OTF";